//Actividades
$(document).on('click','.abreActividadModal', function(){
    
    var id = this.id.substr(10,25);
    $("#_method").val("PUT");
    $("#formActividad").attr('action',"actividades/"+id);
    $(".btnDeleteActividad").css("display","block");
    $(".btnDeleteActividad").attr('id',"delete-"+id);
    $(".campo").val("");

    $.ajax({
        url: "actividades/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#fichaActividadLabel").html("Edición de actividad "+data['nombre']);
            $.each(data,function(index,value){
                if(value != null){
                    if(index == "activa"){
                        if(value == 1){
                            $("#activa").prop("checked",true);
                        } else {
                            $("#activa").prop("checked",false);
                        }
                    } else if(index == "stripe_activo"){
                        if(value == 1 || value === true){
                            $("#stripe_activo").prop("checked",true);
                            $("#stripeConfigDetails").slideDown(200);
                        } else {
                            $("#stripe_activo").prop("checked",false);
                            $("#stripeConfigDetails").slideUp(200);
                        }
                    } else if(index == "stripe_tipo_recurrencia"){
                        $("#stripe_tipo_recurrencia").val(value || 'month');
                    } else if(index == "stripe_product_id"){
                        $("#stripe_product_id").val(value || '');
                    } else if(index == "stripe_price_id"){
                        $("#stripe_price_id").val(value || '');
                    } else if(index == "empresas"){
                        $("#empresa_id").empty();
                        $.each(value,function(index2,value2){
                            if(data['empresa'] != null){
                                if(value2['id'] == data['empresa']['id']){
                                    $("#empresa_id").append("<option selected value='"+value2['id']+"'>"+value2['nombre']+"</option>");
                                }else{
                                    $("#empresa_id").append("<option value='"+value2['id']+"'>"+value2['nombre']+"</option>");
                                }
                            }else{
                                $("#empresa_id").append("<option value='"+value2['id']+"'>"+value2['nombre']+"</option>");
                            }
                        });
                    }else if(index == "mes_completo"){
                        if(value == 1){
                            $("#mes_completo").append("<option value='1' selected>Mes completo</option>");
                            $("#mes_completo").append("<option value='0'>Mes fraccionado</option>");
                        }else{
                            $("#mes_completo").append("<option value='1'>Mes completo</option>");
                            $("#mes_completo").append("<option value='0' selected>Mes fraccionado</option>");
                        }
                    }else{
                        $("#"+index.toLowerCase()).val(value);
                    }
                }
            });

            // Actualizar badge de estado Stripe
            var hasPrice = data['stripe_price_id'] && data['stripe_price_id'].length > 0;
            if (data['stripe_activo'] == 1 && hasPrice) {
                $("#badgeStripeStatus").removeClass("bg-secondary-subtle text-secondary bg-warning-subtle text-warning")
                                       .addClass("bg-success-subtle text-success")
                                       .html("<i class='bi bi-check-circle-fill me-1'></i>Sincronizado");
                $("#btnSyncStripeManual").removeClass("d-none").data("id", id);
            } else if (data['stripe_activo'] == 1 && !hasPrice) {
                $("#badgeStripeStatus").removeClass("bg-secondary-subtle text-secondary bg-success-subtle text-success")
                                       .addClass("bg-warning-subtle text-warning")
                                       .html("<i class='bi bi-clock-history me-1'></i>Pendiente");
                $("#btnSyncStripeManual").removeClass("d-none").data("id", id);
            } else {
                $("#badgeStripeStatus").removeClass("bg-success-subtle text-success bg-warning-subtle text-warning")
                                       .addClass("bg-secondary-subtle text-secondary")
                                       .text("Inactivo");
                $("#btnSyncStripeManual").addClass("d-none");
            }
        }
    }); 
});

// Switch Stripe en Modal Actividad
$(document).on('change', '#stripe_activo', function() {
    if ($(this).is(':checked')) {
        $("#stripeConfigDetails").slideDown(200);
    } else {
        $("#stripeConfigDetails").slideUp(200);
    }
});

// Botón de sincronización manual
$(document).on('click', '#btnSyncStripeManual', function() {
    var id = $(this).data("id");
    if (!id) return;
    var $btn = $(this);
    var originalHtml = $btn.html();
    $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status"></span>');

    $.ajax({
        url: "/actividades/" + id + "/sync-stripe",
        type: "POST",
        data: {
            _token: $('meta[name="csrf-token"]').attr('content')
        },
        success: function(res) {
            $btn.prop('disabled', false).html(originalHtml);
            if (res.success && res.data) {
                if (res.data.product_id) $("#stripe_product_id").val(res.data.product_id);
                if (res.data.price_id) $("#stripe_price_id").val(res.data.price_id);
                $("#badgeStripeStatus").removeClass("bg-secondary-subtle text-secondary bg-warning-subtle text-warning")
                                       .addClass("bg-success-subtle text-success")
                                       .html("<i class='bi bi-check-circle-fill me-1'></i>Sincronizado");
            }
        },
        error: function(xhr) {
            $btn.prop('disabled', false).html(originalHtml);
            var msg = (xhr.responseJSON && xhr.responseJSON.message) ? xhr.responseJSON.message : "Error al sincronizar con Stripe";
            alert(msg);
        }
    });
});

$(document).on('click','.nuevaActividadModal', function(){
    $("#_method").val("POST");
    $("#formActividad").attr('action',"actividades");
    $("#fichaActividadLabel").html("Creación de nueva actividad");
    $(".btnDeleteActividad").css("display","none");
    $(".campo").val("");
    $("#activa").prop("checked", true);
    $("#stripe_activo").prop("checked", false);
    $("#stripeConfigDetails").hide();
    $("#badgeStripeStatus").removeClass("bg-success-subtle text-success bg-warning-subtle text-warning")
                           .addClass("bg-secondary-subtle text-secondary")
                           .text("No sincronizado");
    $("#btnSyncStripeManual").addClass("d-none");
    $.ajax({
        url: "empresas/aux",
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#empresa_id").empty();
            $.each(data,function(index,value){
                $("#empresa_id").append("<option value='"+value['id']+"'>"+value['nombre']+"</option>");
            });
        }
    });
    $("#mes_completo").append("<option value='1'>Mes completo</option>");
    $("#mes_completo").append("<option value='0'>Mes fraccionado</option>");
    $("#duracion_meses").val("1");
    $("#color").val("white");
    $("#background_color").val("#483948");
});
var sociosClaseData = [];
var filtroEstadoActualClase = 'todos';

function renderSociosClase() {
    var searchVal = ($("#buscadorSociosClase").val() || "").toLowerCase().trim();
    var container = $("#socios-lista");
    container.empty();

    var filtrados = sociosClaseData.filter(function(socio) {
        // Filtro de estado
        if (filtroEstadoActualClase === 'activos' && socio.status != 1) return false;
        if (filtroEstadoActualClase === 'inactivos' && socio.status == 1) return false;

        // Búsqueda por texto
        if (searchVal) {
            var fullText = (
                (socio.nombre || "") + " " + 
                (socio.apellidos || "") + " " + 
                (socio.numero_socio || "") + " " + 
                (socio.telefono || "") + " " + 
                (socio.dni || "")
            ).toLowerCase();
            return fullText.indexOf(searchVal) !== -1;
        }
        return true;
    });

    if (filtrados.length === 0) {
        container.html(`
            <div class="text-center py-5 text-muted">
                <i class="bi bi-person-x fs-1 text-secondary opacity-50 mb-2 d-block"></i>
                <h6 class="fw-bold mb-1">No se encontraron socios</h6>
                <p class="small mb-0">Prueba a cambiar el término de búsqueda o el filtro de estado.</p>
            </div>
        `);
        return;
    }

    var tableHtml = `
        <div class="table-responsive">
            <table class="table table-hover align-middle mb-0" style="font-size: 0.88rem;">
                <thead class="table-light text-muted small text-uppercase fw-bold" style="position: sticky; top: 0; z-index: 5;">
                    <tr>
                        <th class="ps-4" style="width: 70px;">Socio</th>
                        <th>Nombre y Apellidos</th>
                        <th>Contacto</th>
                        <th>Edad</th>
                        <th>Estado Acceso</th>
                        <th class="text-end pe-4" style="width: 100px;">Acción</th>
                    </tr>
                </thead>
                <tbody>
    `;

    $.each(filtrados, function(index, socio) {
        var avatarSrc = socio.avatar ? ('storage/' + socio.avatar.replace(/^\//, '')) : 'storage/avatar/noavatar.jpg';
        var isActivo = socio.status == 1;
        var inicial = socio.nombre ? socio.nombre.charAt(0).toUpperCase() : '?';

        tableHtml += `
            <tr style="cursor: pointer;" onclick="window.open('/socios?numero_socio=${socio.numero_socio}', '_blank')">
                <td class="ps-4">
                    <div class="d-flex align-items-center gap-2">
                        <div class="position-relative">
                            <img src="${avatarSrc}" onerror="this.onerror=null; this.src='storage/avatar/noavatar.jpg'" class="rounded-3 shadow-xs border" style="width: 38px; height: 38px; object-fit: cover;">
                            <span class="position-absolute bottom-0 end-0 p-1 rounded-circle ${isActivo ? 'bg-success' : 'bg-danger'} border border-2 border-white" style="width: 10px; height: 10px; transform: translate(25%, 25%);"></span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="fw-bold text-dark mb-0">${socio.nombre || ''} ${socio.apellidos || ''}</div>
                    <span class="badge bg-light text-secondary border px-2 py-0 small fw-bold">#${socio.numero_socio || socio.id}</span>
                </td>
                <td>
                    ${socio.telefono ? `<div><i class="bi bi-telephone text-muted me-1 small"></i><a href="tel:${socio.telefono}" class="text-decoration-none text-dark" onclick="event.stopPropagation();">${socio.telefono}</a></div>` : ''}
                    ${socio.email ? `<div class="small text-muted text-truncate" style="max-width: 200px;"><i class="bi bi-envelope text-muted me-1 small"></i>${socio.email}</div>` : ''}
                    ${!socio.telefono && !socio.email ? `<span class="text-muted small">-</span>` : ''}
                </td>
                <td>
                    <span class="fw-semibold text-dark">${socio.edad ? socio.edad + ' años' : '-'}</span>
                </td>
                <td>
                    ${isActivo ? `
                        <span class="badge bg-success-subtle text-success border border-success-subtle rounded-pill px-2 py-1">
                            <i class="bi bi-check-circle-fill me-1"></i>Activo
                        </span>
                    ` : `
                        <span class="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill px-2 py-1">
                            <i class="bi bi-x-circle-fill me-1"></i>Inactivo
                        </span>
                    `}
                </td>
                <td class="text-end pe-4">
                    <a href="/socios?numero_socio=${socio.numero_socio}" target="_blank" class="btn btn-sm btn-outline-secondary rounded-pill px-2 py-1" title="Ver ficha del socio" onclick="event.stopPropagation();">
                        <i class="bi bi-box-arrow-up-right"></i>
                    </a>
                </td>
            </tr>
        `;
    });

    tableHtml += `
                </tbody>
            </table>
        </div>
    `;

    container.html(tableHtml);
}

$(document).on('click', '.listado-clase', function() {
    var id = this.id.substr(14, 20);
    $(".imprimir-listado").attr('id', "imprimir-listado-" + id);
    $("#buscadorSociosClase").val('');
    filtroEstadoActualClase = 'todos';
    $(".btn-filtro-estado-clase").removeClass('active');
    $(".btn-filtro-estado-clase[data-filtro='todos']").addClass('active');

    $("#socios-lista").html(`
        <div class="text-center py-5 text-muted">
            <div class="spinner-border spinner-border-sm text-secondary me-2" role="status"></div>
            <span>Cargando socios asignados...</span>
        </div>
    `);

    $.ajax({
        url: "actividades/" + id,
        type: "GET",
        dataType: "json",
        success: function(data) {
            $("#listadoClaseLabel").html(data['nombre']);
            $("#listadoClaseSubtitle").html(`Socios inscritos en la actividad (${data.empresa ? data.empresa.nombre : 'Gimnasio'})`);
            
            sociosClaseData = data.assigned_socios || [];

            // Actualizar contadores KPI
            var total = sociosClaseData.length;
            var activos = sociosClaseData.filter(s => s.status == 1).length;
            $("#totalSociosClase strong").text(total);
            $("#activosSociosClase strong").text(activos);

            renderSociosClase();
        }
    });
});

$(document).on('input', '#buscadorSociosClase', function() {
    renderSociosClase();
});

$(document).on('click', '.btn-filtro-estado-clase', function() {
    $(".btn-filtro-estado-clase").removeClass('active');
    $(this).addClass('active');
    filtroEstadoActualClase = $(this).data('filtro');
    renderSociosClase();
});
$(document).on('click','.btnDeleteActividad',function(){
    Swal.fire({
        title: "Estás seguro que deseas eliminar a esta actividad?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: 'No eliminar'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            $("#"+this.id).submit();
        } else if (result.isDenied) {
          Swal.fire("La actividad no se eliminó", "", "info");
        }
      });
});
$(document).on('click','.imprimir-listado',function(){
    var id = this.id.substr(17,20);
    window.open("actividades/listapdf/"+id,"_blank");
});